var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingIconNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6172 18C12.4737 18 14.2542 17.2625 15.5669 15.9497C16.8797 14.637 17.6172 12.8565 17.6172 11C17.6172 9.14348 16.8797 7.36301 15.5669 6.05025C14.2542 4.7375 12.4737 4 10.6172 4C8.76067 4 6.98019 4.7375 5.66744 6.05025C4.35469 7.36301 3.61719 9.14348 3.61719 11C3.61719 12.8565 4.35469 14.637 5.66744 15.9497C6.98019 17.2625 8.76067 18 10.6172 18Z",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6172 12.75C11.0813 12.75 11.5264 12.5656 11.8546 12.2374C12.1828 11.9092 12.3672 11.4641 12.3672 11C12.3672 10.5359 12.1828 10.0908 11.8546 9.76256C11.5264 9.43437 11.0813 9.25 10.6172 9.25C10.1531 9.25 9.70794 9.43437 9.37975 9.76256C9.05156 10.0908 8.86719 10.5359 8.86719 11C8.86719 11.4641 9.05156 11.9092 9.37975 12.2374C9.70794 12.5656 10.1531 12.75 10.6172 12.75Z",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6172 2.25V4",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.6172 19.75V18",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.9922 18.5762L14.1172 17.0625",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.74219 9.48563L6.24219 3.42188",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.1934 15.375L16.6797 14.5",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M3.03906 6.625L4.55281 7.5",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.3672 11H19.3672",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M1.86719 11H3.61719",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.1934 6.625L16.6797 7.5",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M3.03906 15.375L4.55281 14.5",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M14.9922 3.42188L14.1172 4.93563",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M9.74219 12.5156L6.24219 18.5794",
    stroke: "#5F677A",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIconNew);
export default __webpack_public_path__ + "static/media/SettingIconNew.27d3e96cb9a9626c5d901959a0d76ff2.svg";
export { ForwardRef as ReactComponent };